import BaseObject from "./BaseObject";
import BoundaryRect from "./BoundaryRect";
import type Floor from "./Floor";
import Page, { mmToPixel } from "./Page";
import Point from "./Point";
import Room from "./Room";

export default class RoomToFloorTransform extends BaseObject {
  public get className(): string {
    return "RoomToFloorTransform"; // no itx
  }

  transformPoint(pRoom: Point): Point {
    let res = new Point(pRoom.x * this.scale, pRoom.y * this.scale);
    res = new Point(res.x + this.position.x, res.y + this.position.y);

    return res;
  }

  transformPointInvers(pFloor: Point): Point {
    let res = new Point(pFloor.x - this.position.x, pFloor.y - this.position.y);
    res = new Point(res.x / this.scale, res.y / this.scale);

    return res;
  }

  position: Point = new Point(10, 10);
  scale: number = 1;
  scaleAtSubImagesCreationTime?: number = 1;
  rotation: number = 0;
  placed: boolean = true;

  fromJSON(data: any) {
    this.position = data.position;
    this.scale = data.scale;
    this.rotation = data.rotation;
    this.placed = data.placed;
  }

  toJSON(): any {
    return {
      position: this.position,
      scale: this.scale,
      rotation: this.rotation,
      placed: this.placed,
    };
  }

  copy(): RoomToFloorTransform {
    const res = new RoomToFloorTransform();
    res.position = new Point(this.position.x, this.position.y);
    res.scale = this.scale;
    res.rotation = this.rotation;
    res.placed = this.placed;
    return res;
  }

  getCssTransformation(room: Room): string {
    const floorPage = (room.parent as Floor)?.page;

    if (floorPage) {
      const roomPosX = this.position.x; // in cm
      const roomPosY = this.position.y;

      return `scale(${1 / this.scale}) translate(${-roomPosX}px, ${-roomPosY}px) translate(${floorPage.backgroundImagePosition.posX}px, ${floorPage.backgroundImagePosition.posY}px)  scale(${floorPage.backgroundImagePosition.scale})`;
    }
    return "";
  }


  getCssTransformation1(room: Room): { left: number, top: number, scale: number } {
    const floorPage = (room.parent as Floor)?.page;

    if (floorPage) {
      const roomPosX = this.position.x; // in cm
      const roomPosY = this.position.y;

      const scaleFinal = (1 / this.scale) * floorPage.backgroundImagePosition.scale;

      const left = (-roomPosX / this.scale)
        + (floorPage.backgroundImagePosition.posX * scaleFinal);

      const top = (-roomPosY / this.scale)
        + (floorPage.backgroundImagePosition.posY * scaleFinal);

      return { left, top, scale: scaleFinal };
    }
    return { left: 0, top: 0, scale: 1 };

  }

  sizeAndPositionFromBoundingRectWithBorder(newBoundaryRect: BoundaryRect, roomPage: Page) {
    const room = roomPage.parentRoom;
    if (room) {
      const paddingInFloorSpace = room.paddingForBoundingRectInFloorSpace || 0;

      const { width, height } = roomPage.contentAreaInPixel;
      //
      // Calculate Scale for Room
      //
      const scaleForRoomX = (newBoundaryRect.width + paddingInFloorSpace * 2) / width;
      const scaleForRoomY = (newBoundaryRect.height + paddingInFloorSpace * 2) / height;
      this.scale = Math.max(scaleForRoomX, scaleForRoomY);

      console.log("sizeAndPositionFromBoundingRectWithBorder", scaleForRoomX, scaleForRoomY);

      const pageOriginInFloorSpace = new Point(
        (newBoundaryRect.center.x -= (width / 2) * this.scale),
        (newBoundaryRect.center.y -= (height / 2) * this.scale),
      );

      this.position = pageOriginInFloorSpace;
    }
  }

  setNewScale1(newScale: number, page: Page) {
    const pCenterInRoomCoordinates = new Point(
      (page.printableArea.width * 10 * mmToPixel) / 2,
      (page.printableArea.height * 10 * mmToPixel) / 2,
    );

    const pCenterInFloorCoordinates = this.transformPoint(pCenterInRoomCoordinates);

    this.scale = newScale;

    if (this.scale < 0.2) {
      this.scale = 0.2;
    }

    if (this.scale > 5) {
      this.scale = 5;
    }

    const dcx = ((page.printableArea.width * 10 * mmToPixel) / 2) * this.scale;
    const dcy = ((page.printableArea.height * 10 * mmToPixel) / 2) * this.scale;

    this.position.x = pCenterInFloorCoordinates.x - dcx; // dxcInImageCoordinates; // dcxInFloorCooordinates;
    this.position.y = pCenterInFloorCoordinates.y - dcy; //  -dcyInFloorCoordinates;
  }
} // RoomToFloorTransform
